jQuery('document').ready(function ($) {
  $(".navbar-toggler").click(function () {
    $("body").toggleClass('nav-open');
  });

  if ($('.calculator-conta')) {
    var Calculate = function () {
      var total
      if (doc.getValue()) {
        total = employees.getValue() * doc.getValue() * 2 * 0.75 * 30 * 52;
      } else {
        total = employees.getValue() * 2 * 0.75 * 30 * 52;
      }

      function getNumberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }

      $(".year-fee").html('€' + getNumberWithCommas(total));
      $(".year-fee").addClass('animate-fee');
      setTimeout(() => {
        $(".year-fee").removeClass('animate-fee');
      }, 500);
      $(".month-fee").html('€' + getNumberWithCommas((total / 12)));
      console.log(total)
    };

    var sliderUpdate = function () {
      $(".employees").html(employees.getValue());
      $(".docs-weekly").html(doc.getValue());
    };

    var employees = $("#employeesSlider").slider({
      tooltip_position: 'bottom'
    }).on('slideStop', Calculate).on('slide', sliderUpdate).data('slider');
    var doc = $("#documentsSlider").slider({
      tooltip_position: 'bottom'
    }).on('slideStop', Calculate).on('slide', sliderUpdate).data('slider');
  }

  $(".testimonial-1").click(function () {
    $(".testimonial-card").removeClass('active');
    $(".testimonial-1").addClass('active');
    $(".t-content").addClass('d-none');
    $(".t-content.t-1").removeClass('d-none');
  });
  $(".testimonial-2").click(function () {
    $(".testimonial-card").removeClass('active');
    $(".testimonial-2").addClass('active');
    $(".t-content").addClass('d-none');
    $(".t-content.t-2").removeClass('d-none');
  });
  $(".testimonial-3").click(function () {
    $(".testimonial-card").removeClass('active');
    $(".testimonial-3").addClass('active');
    $(".t-content").addClass('d-none');
    $(".t-content.t-3").removeClass('d-none');
  });

  $('.wpcf7-checkbox .wpcf7-list-item-label').after('<span class="checkmark"></span>')

  document.addEventListener( 'wpcf7mailsent', function( event ) {
    $('.js_hideAfterSubmit').hide();
    $('.js_showAfterSubmit').show();
  }, false );
});